import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import DateUtils from 'app/shared/model/date-util';
import { Extrato } from 'app/shared/model/extrato.model';

@Component({
  selector: 'app-dialog-validar-extrato',
  templateUrl: './dialog-validar-extrato.component.html',
  styleUrls: ['./dialog-validar-extrato.component.scss']
})
export class DialogValidarExtratoComponent {

    @Input() extrato?: Extrato;

    constructor(
        public activeModal: NgbActiveModal
    ) { }

    fecharModal(): void {
        this.activeModal.dismiss();
    }

    get competenciaFormatada(): string {
        return DateUtils.formatarData_AAAAMM_Para_MM_AAAA(this.extrato?.competencia ?? null);
    }

    get numeroExtratoFormatado(): string {
        return this.extrato?.numeroExtrato?.trim() ?? '';
    }

    get razaoSocialFormatada(): string {
        return this.extrato?.razaoSocial?.trim().toUpperCase() ?? '';
    }

    get statusAtivo(): boolean {
        return this.extrato?.status?.trim().toLowerCase() === 'ativo';
    }

    get possuiDadosExtratoValidos(): boolean {
        return !!this.numeroExtratoFormatado
            && !!this.razaoSocialFormatada
            && !!this.competenciaFormatada;
    }

}
